import React from 'react'
import TabSearch from '../../NewComponent/TabSearch/tabSearch';
import SelectComp from '../../NewComponent/Select/Select';
import MultiSelect from '../../NewComponent/MultiSelect/MultiSelect';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import debounce from "lodash.debounce";
import { useCallback } from 'react';
export default function Filters() {
  const dispatch = useDispatch();
    const answeredState = useSelector(state=>state.answeredQuestions);
  const [domain, setDomain] = React.useState(answeredState.domains);
  const {updateAnsweredDomainValue, updateAnsweredSortFilterValue, updateAnsweredSearchedQuery, getIsRelevenceAT} = bindActionCreators(Actions, dispatch)
  const onChangeFilter = (e)=>{
    let asdf = answeredState.sortOptions.filter(obj=>obj.value===e);
    updateAnsweredSortFilterValue(asdf[0])
  }
  const onChangeTabSearch = (e)=>{
    updateAnsweredSearchedQuery(e.target.value)
    if(e.target.value.length !== 0){
      getIsRelevenceAT(true);
      if(!answeredState.isRelevence){
        updateAnsweredSortFilterValue(answeredState.relevanceObj)
      }
    }else{
      getIsRelevenceAT(false)
      updateAnsweredSortFilterValue(answeredState.sortOptions[0]);
    }
  }
  const onChangeDomain = (e)=>{
    setDomain(e);
    debouncedFetchOptions(e)
  }
  const debouncedFetchOptions = useCallback(
        debounce((value) => updateAnsweredDomainValue(value), 2000),
        []
      );
  const userState = useSelector((state) => state.user);
  const updatesDomains = (arr) => {
    arr.filter(ar=>{
      ar.label = ar.name;
      ar.value = ar.name;
      return ar;
    })
    return arr;
  };
  return (
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap'}}>
      <div className='mt-1'>
        <TabSearch onChangeFunc={onChangeTabSearch} size={'large'} val={answeredState.searchQuery} />
      </div>
      <div className='mt-1' style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div><SelectComp width={'220px'} isString={false} val={answeredState.sortFilter} onChangeFunc={onChangeFilter} options={answeredState.searchQuery.length===0?answeredState.sortOptions:answeredState.sortOptions.concat([answeredState.relevanceObj])} size={'large'} /></div>
        &nbsp;&nbsp;
        <div>
          <MultiSelect
            size={'large'}
            onChangeFunc={onChangeDomain}
            options={updatesDomains(userState.expertTopics)}
            value={domain}
            // width={220}
            placeholder={'Select Domains'}

          />
        </div>
      </div>
    </div>
  )
}
